import { Dialog, DialogContent, Button, DialogTitle } from '@mui/material';
import { PropsWithChildren, useState } from 'react';
import { useBlocker } from 'react-router-dom';
import { cancelButtonStyle, saveButtonStyle } from '../../../style';
import { StyledDialogActions } from '../../../styledComponents';
import { LoadingButton } from '@mui/lab';

export type PromptProps = {
    when: boolean;
    onConfirm?: () => void | Promise<void>;
    onCancel?: () => void | Promise<void>;
    title?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    navigateOnCancel: boolean;
    waitConfirmResolve: boolean;
};

export default function Prompt({
    when,
    children,
    onConfirm,
    onCancel,
    title = 'Warning',
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    navigateOnCancel = false,
    waitConfirmResolve = true
}: PropsWithChildren<PromptProps>) {
    const [resolved, setResolved] = useState(true);

    const blocker = useBlocker(when);

    const handleClose = async () => {
        blocker.reset && blocker.reset();
    };
    const handleConfirm = async () => {
        if (onConfirm) {
            setResolved(false);
            await onConfirm();

            setTimeout(() => setResolved(true), 1000);
        }

        blocker.proceed && blocker.proceed();
    };

    const handleNo = async () => {
        onCancel && (await onCancel());

        if (navigateOnCancel) {
            blocker.proceed && blocker.proceed();
        } else {
            blocker.reset && blocker.reset();
        }
    };

    return (
        <Dialog open={blocker.state === 'blocked'} onClose={handleClose}>
            <DialogTitle variant="h1">{title}</DialogTitle>
            <DialogContent>{children}</DialogContent>
            <StyledDialogActions>
                {waitConfirmResolve ? (
                    <LoadingButton loading={!resolved} sx={saveButtonStyle} onClick={handleConfirm}>
                        <span>{confirmLabel}</span>
                    </LoadingButton>
                ) : (
                    <Button sx={saveButtonStyle} onClick={handleConfirm}>
                        {confirmLabel}
                    </Button>
                )}
                <Button sx={cancelButtonStyle} onClick={handleNo}>
                    {cancelLabel}
                </Button>
            </StyledDialogActions>
        </Dialog>
    );
}
